// auth.interceptor.ts
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments";
import {AuthService} from "../service/auth.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.auth.token;

    if (token && req.url.startsWith(environment.portal.apiUrl)) {
      const cloned = req.clone({
        setHeaders: {Authorization: `Bearer ${token}`},
      });
      return next.handle(cloned);
    }

    return next.handle(req);
  }
}

